import Atendimentos from "@/pages/atendimentos/Atendimentos.vue";
import DetalhesAtendimento from "@/pages/atendimentos/DetalhesAtendimento.vue";
import Catalogos from "@/pages/catalogos/Catalogos.vue";
import Categorias from "@/pages/catalogos/categorias/Categorias.vue";
import ImportacaoCatalogo from "@/pages/catalogos/importacao/ImportacaoCatalogo.vue";
import ImportacaoMaryKay from "@/pages/catalogos/importacao/ImportacaoMaryKay.vue";
import AlterarImagem from "@/pages/catalogos/produtos/AlterarImagem.vue";
import AlterarPreco from "@/pages/catalogos/produtos/AlterarPreco.vue";
import AlterarProduto from "@/pages/catalogos/produtos/AlterarProduto.vue";
import NovoProduto from "@/pages/catalogos/produtos/NovoProduto.vue";
import Produtos from "@/pages/catalogos/produtos/Produtos.vue";
import PaginasRevista from "@/pages/catalogos/revistas/paginas/PaginasRevista.vue";
import ProdutosPaginasRevista from "@/pages/catalogos/revistas/produtos/ProdutosPaginasRevista.vue";
import Revistas from "@/pages/catalogos/revistas/Revistas.vue";
import CentralNotificacoes from "@/pages/central-notificacoes/CentralNotificacoes.vue";
import Comentarios from "@/pages/central-notificacoes/Comentarios.vue";
import ConfigurarCertificadoInter from "@/pages/certificado-inter/ConfigurarCertificadoInter.vue";
import Consultores from "@/pages/consultores/Consultores.vue";
import Cupons from "@/pages/cupom/Cupons.vue";
import DashboardTv from "@/pages/dashboard-tv/DashboardTv.vue";
import Vendedor from "@/pages/dashboard-vendedor/Vendedor.vue";
import Dashboard from "@/pages/dashboard/Dashboard.vue";
import Emails from "@/pages/emails/Emails.vue";
import EnviosAutomaticos from "@/pages/envios-automaticos/EnviosAutomaticos.vue";
import ExecucoesDiarias from "@/pages/envios-automaticos/ExecucoesDiarias.vue";
import TotalQualitativo from "@/pages/envios-automaticos/TotalQualitativo.vue";
import Detalhes from "@/pages/erros/Detalhes.vue";
import Erros from "@/pages/erros/Erros.vue";
import Eventos from "@/pages/eventos/Eventos.vue";
import AlterarOrdem from "@/pages/faqs/AlterarOrdem.vue";
import Faqs from "@/pages/faqs/Faqs.vue";
import NovoFaq from "@/pages/faqs/NovoFaq.vue";
import Feriados from "@/pages/feriados/Feriados.vue";
import ErroProcessamentoFilaMensagem from "@/pages/filamensagens/ErroProcessamentoFilaMensagem.vue";
import FilaMensagens from "@/pages/filamensagens/FilaMensagens.vue";
import ModalProcessarFilaMensagem from "@/pages/filamensagens/Json.vue";
import ManterFilaMensagem from "@/pages/filamensagens/Manter.vue";
import ProcessarFilaMensagem from "@/pages/filamensagens/Processar.vue";
import Fornecedores from "@/pages/fornecedores/Fornecedores.vue";
import AtendimentoLead from "@/pages/funil/AtendimentoLead.vue";
import Cadastros from "@/pages/funil/Cadastros.vue";
import Estatisticas from "@/pages/funil/estatistica/Estatisticas.vue";
import Funil from "@/pages/funil/Funil.vue";
import PesquisarLeads from "@/pages/funil/PesquisarLeads.vue";
import Home from "@/pages/home/Home.vue";
import AlterarKitDinamico from "@/pages/kits-dinamicos/AlterarKitDinamico.vue";
import KitDinamicoForm from "@/pages/kits-dinamicos/KitDinamicoForm.vue";
import KitsDinamicos from "@/pages/kits-dinamicos/KitsDinamicos.vue";
import NovoKitDinamico from "@/pages/kits-dinamicos/NovoKitDinamico.vue";
import Login from "@/pages/login/Login.vue";
import MetasVendedores from "@/pages/metas-vendedores/MetasVendedores.vue";
import MonitorTrafego from "@/pages/monitor-trafego/MonitorTrafego.vue";
import NotificacoesApple from "@/pages/notificacoes-apple/NotificacoesApple.vue";
import ContaCorrenteParceiros from "@/pages/parceiros/conta-corrente/ContaCorrenteParceiros.vue";
import Parceiros from "@/pages/parceiros/Parceiros.vue";
import AlterarPromocao from "@/pages/promocoes/AlterarPromocao.vue";
import NovoPremio from "@/pages/promocoes/NovoPremio.vue";
import Promocoes from "@/pages/promocoes/Promocoes.vue";
import RelatorioFechamentoVendedores from "@/pages/relatorios/RelatorioFechamentoVendedores.vue";
import RelatorioProdutosMaisVendidos from "@/pages/relatorios/RelatorioProdutosMaisVendidos.vue";
import RelatoriosDeClientes from "@/pages/relatorios/RelatoriosDeClientes.vue";
import AlterarSenha from "@/pages/usuarios/AlterarSenha.vue";
import AlterarUsuario from "@/pages/usuarios/AlterarUsuario.vue";
import NovoUsuario from "@/pages/usuarios/NovoUsuario.vue";
import Usuarios from "@/pages/usuarios/Usuarios.vue";
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import MainComponent from "../Main.vue";

Vue.use(VueRouter);
const routes: Array<RouteConfig> = [
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "",
    name: "main",
    component: MainComponent,
    children: [
      {
        path: "/home",
        name: "home",
        component: Home,
      },
      {
        path: "/Funil",
        name: "Funil",
        component: Funil,
      },
      {
        path: "/Funil/Cadastros",
        name: "cadastros-leads",
        component: Cadastros,
      },
      {
        path: "/Funil/AtendimentoLead/:idLead",
        name: "atendimento-leads",
        component: AtendimentoLead,
      },
      {
        path: "/Funil/Pesquisar",
        name: "pesquisar-leads",
        component: PesquisarLeads,
      },
      {
        path: "/Funil/Estatistica",
        name: "estatistica-leads",
        component: Estatisticas,
      },
      {
        path: "/Atendimentos",
        name: "Atendimentos",
        component: Atendimentos,
      },
      {
        path: "/Atendimentos/detalhes/:idConsultor/:idAtendimento",
        name: "detalhes",
        component: DetalhesAtendimento,
      },
      {
        path: "/consultores/:idConsultor",
        name: "consultores",
        component: Consultores,
      },
      {
        path: "/enviosautomaticos",
        name: "enviosautomaticos",
        component: EnviosAutomaticos,
      },
      {
        path: "/enviosautomaticos/execucoesdiarias",
        name: "execucoesdiarias",
        component: ExecucoesDiarias,
        props: true,
      },
      {
        path: "/envioautomatico/:idEnvioAutomatico/data/:data/qualitativo",
        name: "totalqualitativo",
        component: TotalQualitativo,
        props: true,
      },
      {
        path: "/centralnotificacoes",
        name: "centralnotificacoes",
        component: CentralNotificacoes,
      },
      {
        path: "/comentarios",
        name: "comentarios",
        component: Comentarios,
      },
      {
        path: "/Erro",
        name: "erro",
        component: Erros,
      },
      {
        path: "/Erro/Detalhes/:idErro",
        name: "detalhes-erro",
        component: Detalhes,
      },
      {
        path: "/eventos",
        name: "eventos",
        component: Eventos,
      },
      {
        path: "/monitortrafego",
        name: "monitortrafego",
        component: MonitorTrafego,
      },
      {
        path: "/relatoriosclientes",
        name: "relatoriosclientes",
        component: RelatoriosDeClientes,
      },
      {
        path: "/relatorioprodutosmaisvendidos",
        name: "relatorioprodutosmaisvendidos",
        component: RelatorioProdutosMaisVendidos,
      },
      {
        path: "/relatoriofechamentovendedores",
        name: "relatorio-fechamento-vendedores",
        component: RelatorioFechamentoVendedores,
      },
      {
        path: "/filamensagens/:idConsultor?",
        name: "filamensagens",
        component: FilaMensagens,
        props: true,
        children: [
          {
            path: "manter/:idFilaMensagem",
            name: "manterfilamensagem",
            props: true,
            component: ManterFilaMensagem,
          },
        ],
      },
      {
        path: "/processar/:idProcessamentoFilaMensagem",
        name: "processarfilamensagem",
        props: true,
        component: ProcessarFilaMensagem,
        children: [
          {
            path: "item/:idItemProcessamentoFilaMensagem/:campo?",
            name: "verjsonprocessamento",
            props: true,
            component: ModalProcessarFilaMensagem,
          },
          {
            path: "erro/:idItemProcessamentoFilaMensagem",
            name: "erroprocessamentofilamensagem",
            props: true,
            component: ErroProcessamentoFilaMensagem,
          },
        ],
      },
      {
        path: "/feriados",
        name: "feriados",
        component: Feriados,
      },
      {
        path: "/usuarios",
        name: "usuarios",
        component: Usuarios,
      },
      {
        path: "/usuarios/criar",
        name: "usuarios-criar",
        component: NovoUsuario,
      },
      {
        path: "/usuarios/alterar/:id",
        name: "usuarios-alterar",
        component: AlterarUsuario,
      },
      {
        path: "/usuarios/alterar-senha/:id",
        name: "usuarios-alterar-senha",
        component: AlterarSenha,
      },
      {
        path: "/promocoes",
        name: "promocoes",
        component: Promocoes,
      },
      {
        path: "/alterarpromocao/:idPromocao",
        name: "alterarpromocao",
        component: AlterarPromocao,
        props: true,
      },
      {
        path: "/alterarpromocao/:idPromocao/novopremio/:colocacao/:idPremioPromocao",
        name: "promocao-premio",
        component: NovoPremio,
      },
      {
        path: "/catalogos",
        name: "catalogos",
        component: Catalogos,
      },
      {
        path: "/cupons",
        name: "cupons",
        component: Cupons,
      },
      {
        path: "/importacao",
        name: "importacao-mary-kay",
        component: ImportacaoMaryKay,
        props: true,
      },
      {
        path: "/importacao/{:idCatalogo}",
        name: "importacao-catalogo",
        component: ImportacaoCatalogo,
        props: true,
      },
      {
        path: "/catalogos/:idCatalogo/produtos",
        name: "catalogos-produtos",
        component: Produtos,
        props: true,
      },
      {
        path: "/catalogos/:idCatalogo/produtos/novo",
        name: "catalogos-produtos-novo",
        component: NovoProduto,
      },
      {
        path: "/catalogos/:idCatalogo/produtos/alterar/:id",
        name: "catalogos-produtos-alterar",
        component: AlterarProduto,
      },
      {
        path: "/catalogos/:idCatalogo/produtos/alterarpreco/:id",
        name: "catalogos-produtos-alterar-preco",
        component: AlterarPreco,
      },
      {
        path: "/catalogos/:idCatalogo/produtos/alterarimagem/:id",
        name: "catalogos-produtos-alterar-imagem",
        component: AlterarImagem,
      },
      {
        path: "/catalogos/:idCatalogo/produtos/duplicarproduto/:id",
        name: "catalogos-produtos-duplicar-produto",
        component: NovoProduto,
      },
      {
        path: "/catalogos/:idCatalogo/revistas",
        name: "catalogos-revistas",
        component: Revistas,
        props: true,
      },
      {
        path: "/catalogos/:idCatalogo/revistas/:idRevista/paginas",
        name: "catalogos-revistas-paginas",
        component: PaginasRevista,
        props: true,
      },
      {
        path: "/catalogos/:idCatalogo/revistas/:idRevista/produtos",
        name: "catalogos-revistas-produtos",
        component: ProdutosPaginasRevista,
        props: true,
      },
      {
        path: "/kitsdinamicos/:idKitDinamico/kitdinamicoform",
        name: "kitsdinamicos-kitdinamicoform",
        component: KitDinamicoForm,
        props: true,
      },
      {
        path: "/catalogos/:idCatalogo/categorias",
        name: "catalogos-categorias",
        component: Categorias,
        props: true,
      },
      {
        path: "/fornecedores",
        name: "fornecedores",
        component: Fornecedores,
      },
      {
        path: "/parceiros",
        name: "parceiros",
        component: Parceiros,
      },
      {
        path: "/parceiros/:idConsultor/contacorrente",
        name: "contacorrente",
        component: ContaCorrenteParceiros,
        props: true,
      },
      {
        path: "/kitsdinamicos",
        name: "kitsdinamicos",
        component: KitsDinamicos,
      },
      {
        path: "/email",
        name: "email",
        component: Emails,
      },
      {
        path: "/kitsdinamicos/novo/",
        name: "novo-kitdinamico",
        component: NovoKitDinamico,
      },
      {
        path: "/kitsdinamicos/alterar/:id",
        name: "alterar-kitdinamico",
        component: AlterarKitDinamico,
      },
      {
        path: "/notificacoesapple",
        name: "notificacoesapple",
        component: NotificacoesApple,
      },
      {
        path: "/faqs",
        name: "faqs",
        component: Faqs,
      },
      {
        path: "/faqs/manter/:id?",
        name: "faqs-manter",
        component: NovoFaq,
      },
      {
        path: "/faqs/alterarordem/:id?",
        name: "faqs-alterarordem",
        component: AlterarOrdem,
      },
      {
        path: "/dashboard",
        name: "dashboard",
        component: Dashboard,
      },
      {
        path: "/dashboard/vendedor",
        name: "dashboard-vendedor",
        component: Vendedor,
      },
      {
        path: "/configuracoes/metas-vendedores",
        name: "metas-vendedores",
        component: MetasVendedores,
      },
      {
        path: "configuracoes/inter",
        name: "configuracoes-inter",
        component: ConfigurarCertificadoInter,
      },
    ],
  },
  {
    path: "/tv",
    name: "tv",
    component: DashboardTv,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: function () {
    return {
      x: 0,
      y: 0,
    };
  },
});

export default router;
